import axios from "axios"

import {
    removeErrorsOnFields,
    cleanInputsValues,
    addErrorOnField
} from "./fields"

/**
 * All or one parameter is missing ( not set )
 * @type {string}
 */
const WP_REST_API_MISSING_PARAM = "rest_missing_callback_param"

/**
 * All params are sent but some are invalid
 * @type {string}
 */
const WP_REST_API_INVALID_PARAM = "rest_invalid_param"

const postWpRestApi = async (url, data, config) => {

    config = config ? {
        headers: {
            'content-type': 'multipart/form-data' // important form FormData
        },
        onUploadProgress: progressEvent => {
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
        },
        ...config
    } : {}

    try {

        const response = await axios.post(url, data, config)

        return {...response, success: true}

    } catch (e) {

        const response = e.response

        if ( e.message === "Network Error") {
            console.log("Network error", e.message, e.response)
            return;
        }

        if (response === undefined ) {
            console.log("Catch javascript error", e.message)
            return;
        }

        console.error('Failure!')
        console.error(response)

        const params = response.data.data.params
        let error_type = ""

        if (response.data.code === WP_REST_API_MISSING_PARAM) {

            /**
             * params: Array of strings representing each missing param
             */
            error_type = WP_REST_API_MISSING_PARAM

        } else if (response.data.code === WP_REST_API_INVALID_PARAM) {

            /**
             * params: Object ( collection ) of each parameters
             */
            error_type = WP_REST_API_INVALID_PARAM
        }

        return {
            success: false,
            error_type,
            params
        }

    }

}

const wpRestApiAddFieldsError = (response, $inputs, inputInvalidMessageSelector, defaultParentSelector = ".field-group") => {

    if ( response.error_type === WP_REST_API_INVALID_PARAM ) {

        removeErrorsOnFields($inputs, defaultParentSelector)

        const params = response.params

        for (let key in params) {

            if (params.hasOwnProperty(key)) {

                // Add error classes
                $inputs.forEach($input => {
                    const nameWithoutBrackets = $input.getAttribute("name").replace("[]", "")
                    if (nameWithoutBrackets === key) {
                        addErrorOnField($input, inputInvalidMessageSelector, params[key])
                    }
                })

            }

        }

    }
}

const wpRestApiHandleInitianInputChecked = ($inputs) => {
    $inputs.forEach($input => {
        if ($input.getAttribute("type") === "checkbox") {
            $input.dataset.initialCheck = $input.checked ? 1 : 0
        } else {
            $input.setAttribute("data-initial-value", $input.value)
        }
    })
}

export {
    postWpRestApi,
    WP_REST_API_INVALID_PARAM,
    WP_REST_API_MISSING_PARAM,
    removeErrorsOnFields,
    cleanInputsValues,
    wpRestApiAddFieldsError,
    wpRestApiHandleInitianInputChecked
}
